import Gem from "./Gem";

import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function GemDiscover(props) {
    const {store, color, index} = props;
    const circleSize = 50;
    const isSelected = store.selectedIndices.indexOf(index) >= 0;

    return (
        <svg width={circleSize} height={circleSize}>
            <Gem onClick={() => {
                store.selectIndex(index, true);
            }}
                 cx={circleSize / 2}
                 cy={circleSize / 2}
                 fill={color}
                 progress={Number.MAX_VALUE}
                 activated={!isSelected}
                 r={circleSize / 2 - 1}
            />
        </svg>

    );
}

export default observer(GemDiscover);
